var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4836 5.63271C14.7918 5.32447 14.7918 4.8247 14.4836 4.51646C14.1753 4.20822 13.6755 4.20822 13.3673 4.51646L9.50001 8.38375L5.63272 4.51646C5.32447 4.20822 4.82471 4.20822 4.51647 4.51646C4.20822 4.8247 4.20822 5.32447 4.51647 5.63271L8.38376 9.5L4.51647 13.3673C4.20822 13.6755 4.20822 14.1753 4.51647 14.4835C4.82471 14.7918 5.32447 14.7918 5.63272 14.4835L9.50001 10.6163L13.3673 14.4835C13.6755 14.7918 14.1753 14.7918 14.4836 14.4835C14.7918 14.1753 14.7918 13.6755 14.4836 13.3673L10.6163 9.5L14.4836 5.63271Z",
    fill: "#D9C5C5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_165_12307",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 11,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4836 5.63271C14.7918 5.32447 14.7918 4.8247 14.4836 4.51646C14.1753 4.20822 13.6755 4.20822 13.3673 4.51646L9.50001 8.38375L5.63272 4.51646C5.32447 4.20822 4.82471 4.20822 4.51647 4.51646C4.20822 4.8247 4.20822 5.32447 4.51647 5.63271L8.38376 9.5L4.51647 13.3673C4.20822 13.6755 4.20822 14.1753 4.51647 14.4835C4.82471 14.7918 5.32447 14.7918 5.63272 14.4835L9.50001 10.6163L13.3673 14.4835C13.6755 14.7918 14.1753 14.7918 14.4836 14.4835C14.7918 14.1753 14.7918 13.6755 14.4836 13.3673L10.6163 9.5L14.4836 5.63271Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_165_12307)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "#D9C5C5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.7d462124353150ad134f2d6926fedf44.svg";
export { ForwardRef as ReactComponent };